<template>
  <v-select
    class="base-dropdown inherit--font"
    flat
    hide-no-data
    menu-icon="mdi:mdi-chevron-down"
    :menu-props="{
      maxWidth: 260
    }"
    v-bind="$attrs"
  >
    <template v-for="_, slot in $slots" #[slot]>
      <slot :name="slot" />
    </template>
  </v-select>
</template>
<script setup lang="ts">
  import { VSelect } from 'vuetify/components'

  const $slots = defineSlots<Record<string, any>>()

</script>
